import { motion } from "framer-motion";
import companyLogo from "../assets/2.png";

const SubmissionSuccess = () => {
  return (
    <div style={styles.container}>
      {/* Logo slides in, grows into place */}
      <motion.img
        src={companyLogo}
        alt="Sidney Lee Logo"
        layoutId="app-logo"
        initial={{ y: -200, scale: 0.6, opacity: 1 }}
        animate={{ y: 0, scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        style={styles.logo}
      />

      {/* Heading fades in AFTER logo */}
      <motion.h1
        style={styles.heading}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.3, duration: 0.8, ease: "easeOut" }}
      >
        Application Submitted Successfully
      </motion.h1>

      {/* Message fades in AFTER heading */}
      <motion.p
        style={styles.message}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.9, duration: 0.8, ease: "easeOut" }}
      >
        A confirmation email will be sent to you shortly.
      </motion.p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "700px",
    margin: "0 auto",
    padding: "40px 20px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  logo: {
    width: "200px",
    marginBottom: "30px",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    marginBottom: "16px",
    color: "#333",
  },
};

export default SubmissionSuccess;
